import React from 'react';
import { Paper, Typography, Box, Skeleton } from '@mui/material';

const StatCard = ({ title, value, color, loading }) => (
  <Paper 
    elevation={0}
    className="flex-1 min-w-[140px] px-4 py-2.5 rounded-md relative transition-all duration-200"
    sx={{ 
      background: '#0f172a', 
      border: `1px solid ${color}`
    }}
  >
    <Typography 
      className="font-bold uppercase tracking-[0.1em] text-[9px] mb-0.5"
      sx={{ color: color, opacity: 0.9 }}
    >
      {title}
    </Typography>
    
    <Typography 
      variant="h5" 
      className="font-black tabular-nums tracking-tight"
      sx={{ color: '#f8fafc' }} // Off-white for crisp contrast
    >
      {loading ? (
        <Skeleton variant="text" width="60%" sx={{ bgcolor: 'rgba(255, 255, 255, 0.1)' }} />
      ) : (
        Number(value).toLocaleString('en-IN')
      )}
    </Typography>

    {/* Subtle Glow Effect */}
    <Box 
      className="absolute top-0 right-0 w-8 h-full opacity-20"
      sx={{ 
        background: `linear-gradient(to left, ${color}, transparent)`,
        filter: 'blur(15px)' 
      }}
    />
  </Paper>
);

const SkuReportAnalysis = ({ totalQuotation, totalSku, totalUser, totalClient, totalQty, loading }) => {
  const stats = [
    { title: "Quotations", value: totalQuotation, color: "#38bdf8" }, // Sky Blue
    { title: "SKUs", value: totalSku, color: "#a78bfa" },           // Soft Purple
    { title: "Users", value: totalUser, color: "#4ade80" },          // Neon Green
    { title: "Clients", value: totalClient, color: "#fbbf24" },      // Amber
    { title: "Quantity", value: totalQty, color: "#f87171" },        // Soft Red
  ];

  return (
    <Box className="w-full flex flex-wrap items-center gap-3 mb-4">
      {stats.map((stat, index) => (
        <StatCard key={index} {...stat} loading={loading} />
      ))}
    </Box>
  );
};

export default SkuReportAnalysis;